import citiesData from 'shared/@generated/cities.json';

export interface City {
  country: string;
  name: string;
  slug: string;
  latitude: number;
  longitude: number;
  feature_code: string;
  population: number;
}

export const cities = citiesData.cities as City[];

export const citiesUpdatedAt = citiesData.updated_at;
